const handleGalleryImageClick = (e) => {
	e.preventDefault();

	const featuredImg = $('.images > .featured-image img');
	const src = $(e.target)
		.attr('src');
	const alt = $(e.target)
		.attr('alt');

	$(featuredImg)
		.attr('src', src)
		.attr('alt', alt);
};

const initProductGallery = () => {

	thumbnailImages = $('.vtc-single-product .gallery-image > a');

	// Scrape out fancybox atts, add custom click handler
	thumbnailImages
		.off('click')
		.removeAttr('class')
		.removeAttr('rel')
		.removeAttr('data-fancybox')
		.on('click', (e) => handleGalleryImageClick(e));

	// I'm not sure why this is here, but I hesitate to remove it.
	if ($('body')
		.hasClass('single-vtc_projects')) {
		$.each(victaulicThemeVars.projects, (key, value) => {
			if (value === 'on') {
				$(key)
					.remove();
			}
		});
	}
};

// eslint-disable-next-line no-unused-vars
(($) => {
	initProductGallery();
})(jQuery);

document.addEventListener('facetwp-loaded', function () {
	fUtil('.facetwp-depth').prev('.facetwp-checkbox').addClass('facetwp-parent');
});
